/**
 * 全局配置文件
 */
export default {
  title: "微考勤",
  indexTitle: '微考勤',
  clientId: 'attenceapp', // 客户端id
  clientSecret: 'attenceapp_secret', // 客户端密钥
  key: 'attenceapp',//配置主键,目前用于存储
  tokenTime: 6000,
  //http的status默认放行不才用统一处理的,
  statusWhiteList: [],
  // 授权地址
  authUrl: 'http://localhost/blade-auth/oauth/render'
}



// WEBPACK FOOTER //
// ./src/utils/website.js